import React, { useEffect, useState } from 'react';
import { Column, Row } from 'react-foundation';
import * as organizationsAPI from '../../../api/organizationsAPI';

/**
 * Edit Organization type page
 */
const EditOrganizationType = ({ organization }) => {
	const fieldDefaultsTemplate = {
		industries: [],
		interestAreas: [],
		presenceValidations: [],
		regions: [],
		organizationTypes: [],
	};

	const [fieldDefaults, setFieldDefaults] = useState(fieldDefaultsTemplate);
	let orgTypeIndex = 0;

	useEffect(() => {
		fetchFieldAttributes();
	}, []);

	const fetchFieldAttributes = async () => {
		let fieldResponse = await organizationsAPI.getFieldAttributes();
		setFieldDefaults(fieldResponse.data);
	};

	const onSelect = (event) => {
		orgTypeIndex = event.target.value;
	};

	const redirectToEditPage = () => {
		location.assign(`/organizations/${organization.slug}/edit`);
	};

	const handleSubmit = () => {
		try {
			// check for response.status == 200?
			organizationsAPI
				.putOrganizationType(
					organization.id,
					fieldDefaults.organizationTypes[orgTypeIndex][1]
				)
				.then(() => {
					redirectToEditPage();
				});
		} catch (e) {
			console.error(e);
		}
	};

	return (
		<div className="edit-organization-type">
			<Row>
				<Column small={12}>
					<h1>
						Change the Organization type for{' '}
						{organization?.legal_name} (
						{organization?.organization_type})
					</h1>
					<p className="body-font">
						Please note: Changing the type of an organization may
						result in some data loss.
					</p>
					<h3 className="header-font">Organization Type *</h3>
					<select
						className="body-font"
						defaultValue=""
						onChange={(event) => onSelect(event)}
					>
						{fieldDefaults?.organizationTypes?.map(
							(orgType, index) => {
								return (
									<option value={index} key={index}>
										{orgType[0]}
									</option>
								);
							}
						)}
					</select>
				</Column>
			</Row>

			<Row>
				<Column>
					<div
						className="secondary-button float-left"
						onClick={redirectToEditPage}
					>
						<p className="body-font">Cancel</p>
					</div>

					<div
						className="primary-button float-right mobile-top-20px-margin"
						onClick={handleSubmit}
					>
						<p className="body-font">Save</p>
					</div>
				</Column>
			</Row>
		</div>
	);
};

export default EditOrganizationType;
